module.exports = __webpack_public_path__ + "assets/img/kv-03e9cfa3.jpg";